export const SAT_BOOTCAMP_101_TRAINING_SLUG = 'sat-bootcamp-101'
export const SAT_TIPS_TRAINING_SLUG = 'sat-tips'
export const OLD_AUDITOR_TRAINING_SLUG = 'auditor-training'
export const SAFETY_TRAINING_SLUG = 'safety'
export const SAFETY_AND_PERSONAL_BOUNDARIES_TRAINING_SLUG = 'safety-and-personal-boundaries'
export const SAT_BOOTCAMP_SCORE_RANGE_TRAINING_SLUG = 'sat-bootcamp-score-range'
export const SAT_BOOTCAMP_DIGITAL_SAT_TRAINING_SLUG = 'sat-bootcamp-digital-sat'
export const SAT_BOOTCAMP_CB_TREATMENT_ADDITIONAL_TRAINING_SLUG = 'cb1-additional-training'
export const SAT_BOOTCAMP_CB_CONTROL_ADDITIONAL_TRAINING_SLUG = 'cb2-additional-training'
export const CAW_THE_ESSAY_TRAINING_SLUG = 'caw-the-essay'
export const CAW_THE_APPLICATION_TRAINING_SLUG = 'caw-the-application'
// Training slug is still finding-your-fit because we renamed the training but generally should avoid changing slugs
export const CAW_COLLEGE_LIST_TRAINING_SLUG = 'caw-finding-your-fit'
export const CAW_FINANCIAL_AID_DECODED_TRAINING_SLUG = 'caw-financial-aid-decoded'
export const CAW_101_TRAINING_SLUG = 'caw-101'
export const SESSION_DESCRIPTION_TRAINING_SLUG = 'session-description'
export const SAT_BOOTCAMP_ONBOARDING_TRAINING_SLUG = 'sat-bootcamp-onboarding'
export const DEALING_WITH_CONFLICT_TRAINING_SLUG = 'dealing-with-conflict'
export const DATA_PROTECTION_TRAINING_SLUG = 'data-protection'
export const MANAGING_TRAINING_SLUG = 'managing'
export const VOLUNTEER_LEADERSHIP_TRAINING_SLUG = 'volunteer-leadership'
export const WORK_LIFE_BALANCE_TRAINING_SLUG = 'work-life-balance-training'
export const LEARNING_LABS_101_TRAINING_SLUG = 'learning-labs-101'
export const FINAL_EXAM_PREP_LEARNING_LABS_TRAINING_SLUG = 'final-exam-prep-learning-labs'
export const LAY_THE_FOUNDATION_TRAINING_SLUG = 'lay-the-foundation'
export const ENGAGE_ACTIVELY_TRAINING_SLUG = 'engage-actively'
export const ADJUST_AS_NEEDED_TRAINING_SLUG = 'adjust-as-needed'
export const DEVELOP_CONNECTIONS_TRAINING_SLUG = 'develop-connections'
export const PEER_REVIEW_TRAINING_SLUG = 'peer-review-training'

export const LEADS_TRAINING_SLUGS = [
  LAY_THE_FOUNDATION_TRAINING_SLUG,
  ENGAGE_ACTIVELY_TRAINING_SLUG,
  ADJUST_AS_NEEDED_TRAINING_SLUG,
  DEVELOP_CONNECTIONS_TRAINING_SLUG,
  SAFETY_TRAINING_SLUG,
]

export const SAT_BOOTCAMP_REQUIRED_TRAINING_SLUGS = [
  ...LEADS_TRAINING_SLUGS,
  SAT_BOOTCAMP_101_TRAINING_SLUG,
]

export const PROGRAM_TRAINING_SLUGS = [
  CAW_THE_ESSAY_TRAINING_SLUG,
  CAW_THE_APPLICATION_TRAINING_SLUG,
  CAW_101_TRAINING_SLUG,
  CAW_COLLEGE_LIST_TRAINING_SLUG,
  CAW_FINANCIAL_AID_DECODED_TRAINING_SLUG,
  LEARNING_LABS_101_TRAINING_SLUG,
]

const VOLUNTEER_TRAINING_SLUGS = [
  VOLUNTEER_LEADERSHIP_TRAINING_SLUG,
  DEALING_WITH_CONFLICT_TRAINING_SLUG,
  DATA_PROTECTION_TRAINING_SLUG,
  MANAGING_TRAINING_SLUG,
  WORK_LIFE_BALANCE_TRAINING_SLUG,
]

// Trainings that are required to host a particular series or complete a particular action, e.g. peer reviewing. These trainings automatically give volunteer hours.
export const REQUIRED_TRAININGS_SLUGS = [
  ...LEADS_TRAINING_SLUGS,
  SAT_TIPS_TRAINING_SLUG,
  SAT_BOOTCAMP_101_TRAINING_SLUG,
  ...PROGRAM_TRAINING_SLUGS,
  SAT_BOOTCAMP_DIGITAL_SAT_TRAINING_SLUG,

  SAT_BOOTCAMP_ONBOARDING_TRAINING_SLUG,
  ...VOLUNTEER_TRAINING_SLUGS,
  LEARNING_LABS_101_TRAINING_SLUG,
  PEER_REVIEW_TRAINING_SLUG,
  // The following trainings used to give volunteer hours, but they are no longer in use
  // 'preparing-to-run-a-live-help-room',
  // 'series-training',
]

export const TYPEFORM_URL_PREFIX = 'https://form.typeform.com/to/'
